import React, { useState, useEffect } from "react";
import MetaTags from "react-meta-tags";
import imgLogo from "assets/images/logo.png";
import { Card, CardBody, Col, Container, Row, Spinner } from "reactstrap";
import { SuccessOk } from "configs/statusCode";
// Redux
import { Link } from "react-router-dom";
import { AvField, AvForm } from "availity-reactstrap-validation";
import AuthService from "services/Admin/AuthService";
import "./login.scss";
import { adminPrefix } from "configs/routePrefix";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import { authenticate, setNavigate } from "store/Auth/actions";

const Login = (props) => {
	const [showPassword, setShowPassword] = useState(true);
	const [password, setPassword] = useState("");
	const [loading, setLoading] = useState(false);
	const dispatch = useDispatch();
	const AuthData = useSelector((state) => state.Auth);

	const handleValidSubmit = (event, values) => {
		setLoading(true);
		AuthService.login(values)
			.then((res) => {
				dispatch(setNavigate(""));
				if (!res.access_token) {
					throw new Error("Faild Login");
				} else {
					dispatch(
						authenticate({
							token: res.access_token,
							email: values.email,
							user_name: res.name,
							userType: "admin",
							permissions: res.permissions,
							role: res.role,
						})
					);
					const isExist = (data) =>
						res.permissions.includes(data) ||
						values.email === "admin@meras.com";
					if (!!AuthData.navigateTo) {
						props.history.push(`${adminPrefix}/${AuthData.navigateTo}`);
					} else {
						if (isExist("dashboard.view")) {
							props.history.push(`${adminPrefix}/dashboard`);
						} else {
							props.history.push(`${adminPrefix}/home`);
						}
					}
					AuthService.loginWithJwt(res.access_token);
				}
			})
			.catch((e) => {
				setLoading(false);
			});
	};

	useEffect(() => {
		if (AuthData.lang !== "en") {
			dispatch(
				authenticate({
					lang: "en",
				})
			);
		}
	}, [AuthData.lang]);
	return (
		<React.Fragment>
			<MetaTags>
				<title> Login </title>
			</MetaTags>
			<div className="account-pages">
				<div className="bgImage">
					<Container fluid>
						<Row className="justify-content-center text-left" dir="rtl">
							<Col md={8} lg={7} xl={6} className="p-lg-0 p-md-0" dir="ltr">
								<Card className="overflow-hidden mt-5 mb-0">
									<CardBody className="text-center">
										<img src={imgLogo} className="mt-3" />
										<p className="fw-bold font-size-18 fw-bold pt-2 mb-2">
											Login
										</p>
										<p className="textMuted font-size-13">
											Use you email address and password to can login
										</p>
										<div className="p-2">
											<AvForm
												className="form-horizontal formWithLabel"
												onValidSubmit={(e, v) => {
													handleValidSubmit(e, v);
												}}>
												<div className="mb-3">
													<AvField
														name="email"
														label="Email Address"
														className="form-control mb-3"
														placeholder="Enter your Email Address"
														type="email"
														required
													/>
												</div>

												<div className="mb-3 position-relative">
													<AvField
														name="password"
														label="Password"
														type={showPassword ? "password" : "text"}
														required
														onChange={(e) => setPassword(e.target.value)}
														placeholder="Enter your Email Password"
													/>
													<div
														style={{
															position: "absolute",
															top: "12px",
															right: "10px",
														}}
														onClick={() => setShowPassword(!showPassword)}>
														{password.trim().length !== 0 ? (
															showPassword ? (
																<i className="fas fa-eye-slash"></i>
															) : (
																<i className="fas fa-eye  "></i>
															)
														) : null}
													</div>
												</div>
												<div className="mt-4 text-end">
													<Link
														to={`${adminPrefix}/forget-password`}
														className="textMuted text-decoration-underline">
														Forgot your password?
													</Link>
												</div>
												<div className="mt-4 d-grid">
													{loading ? (
														<div className="m-auto btnHeight">
															<Spinner color="success"></Spinner>
														</div>
													) : (
														<button
															className="btn btn-success btnHeight w-100"
															type="submit">
															Login
														</button>
													)}
												</div>
												{/* <div className='mt-4 text-end text-center'>
                          <Link
                            to={`${adminPrefix}/signup`}
                            className='textMuted text-decoration-underline'>
                           Don't have an Account ? Register now 
                          </Link>
                        </div> */}
											</AvForm>
										</div>
									</CardBody>
								</Card>
							</Col>
						</Row>
					</Container>
				</div>
			</div>
		</React.Fragment>
	);
};

const mapStateToProps = (state) => {
	const { error } = state.Login;
	return { error };
};
export default Login;
// export default withRouter(
//     connect(mapStateToProps, {loginUser, apiError, socialLogin})(Login)
// )
